{
  "steplist": "Adım Listesi"
}
